import React from "react";
import { Link } from "react-router-dom";

const MOODS = [
  {
    name: "Effortless",
    image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=600&h=800&fit=crop&q=80",
    link: "/search?q=effortless",
  },
  {
    name: "Polished",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=600&h=800&fit=crop&q=80",
    link: "/search?q=polished",
  },
  {
    name: "Relaxed",
    image: "https://images.unsplash.com/photo-1499939667766-4afceb292d05?w=600&h=800&fit=crop&q=80",
    link: "/search?q=relaxed",
  },
  {
    name: "Evening",
    image: "https://images.unsplash.com/photo-1566207466184-b0d39f417f77?w=600&h=800&fit=crop&q=80",
    link: "/search?q=evening",
  },
];

export function MoodDiscovery() {
  return (
    <section className="fashion-section">
      <div className="fashion-container">
        <div className="fashion-section-header text-center mx-auto mb-12">
          <p className="text-overline mb-3">Shop By Mood</p>
          <h2 className="font-display text-display-sm font-light">Discover Your Style</h2>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {MOODS.map((mood) => (
            <Link
              key={mood.name}
              to={mood.link}
              className="group relative overflow-hidden aspect-[3/4]"
            >
              <img
                src={mood.image}
                alt={mood.name}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="font-display text-2xl text-white font-light tracking-wide uppercase">
                  {mood.name}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
